<div
  class="overlay-loader-wrapper"
  *ngIf="show"
>
  <div
    class="spinner-grow overlay-loader"
    role="status"
  >
    <span class="visually-hidden">Loading...</span>
  </div>
</div>
